import React, { Component } from "react";
import { connect } from "react-redux";
import { ADR_EDIT } from "../../_constants/actionConstants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class AdrLocTestPerformedRowV3 extends Component {
  state = {
    formData: {
      fieldTestTypeId: 0,
      numberOfTestsOrSamplesTaken: "",
      remarks: "",
    },
  };

  componentDidMount() {
    const { testPerformed: locTp } = this.props;
    const formData = {
      fieldTestTypeId: locTp.fieldTestTypeId,
      numberOfTestsOrSamplesTaken: locTp.numberOfTestsOrSamplesTaken,
      remarks: locTp.remarks,
    };
    this.setState({ formData });
  }

  componentDidUpdate(prevProps, prevState) {
    const { testPerformed: prevTp } = prevProps;
    const { testPerformed: currTp } = this.props;

    if (
      prevTp.fieldTestTypeId !== currTp.fieldTestTypeId ||
      prevTp.numberOfTestsOrSamplesTaken !== currTp.numberOfTestsOrSamplesTaken ||
      prevTp.remarks !== currTp.remarks
    ) {
      this.setState({
        formData: {
          fieldTestTypeId: currTp.fieldTestTypeId,
          numberOfTestsOrSamplesTaken: currTp.numberOfTestsOrSamplesTaken,
          remarks: currTp.remarks,
        },
      });
    }
  }

  handleChange = (e) =>
    this.setState(
      { formData: { ...this.state.formData, [e.target.name]: e.target.value } },
      this.props.markAdrDirty
    );

  handleChange_select = (e) => {
    const { update, markAdrDirty } = this.props;
    update({ [e.target.name]: e.target.value });
    markAdrDirty();
  };

  handleBlur = (e) => this.props.update({ [e.target.name]: e.target.value });

  render() {
    const { formData } = this.state;
    const { status, wpTabId, clientId, locTpIndex, fieldTestTypes, handleClick_delete } =
      this.props;
    const idSuffix = `${wpTabId}_${clientId}_${locTpIndex}`;
    return (
      <div className="locwp-row-tp__tr">
        <div className="locwp-row-tp__td--test-type">
          <select
            name="fieldTestTypeId"
            id={`locTpFieldTestType_${idSuffix}`}
            className="form-control"
            onChange={this.handleChange_select}
            value={formData.fieldTestTypeId}
            disabled={status.isReadOnly}
          >
            <option key="tpKey_0" value={0}>
              (Select Test Type)
            </option>
            {fieldTestTypes &&
              fieldTestTypes.map((tt) => (
                <option key={`tpKey_${tt.fieldTestTypeId}`} value={tt.fieldTestTypeId}>
                  {tt.fieldTestCode + " - " + tt.fieldTestDescription}
                </option>
              ))}
          </select>
        </div>
        <div className="locwp-row-tp__td--count">
          <input
            type="number"
            name="numberOfTestsOrSamplesTaken"
            id={`numberOfTestsOrSamplesTaken_${idSuffix}`}
            className="form-control"
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            value={formData.numberOfTestsOrSamplesTaken}
            disabled={status.isReadOnly}
          />
        </div>
        <div className="locwp-row-tp__td--remarks">
          <input
            type="text"
            name="remarks"
            id={`locMmUoM_${idSuffix}`}
            className="form-control"
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            value={formData.remarks}
            disabled={status.isReadOnly}
          />
        </div>
        <div className="locwp-row-tp__td--del">
          <button
            name="deleteLocTestPerformedRow"
            id={`deleteLocMm_${idSuffix}`}
            className="btn btn-outline-danger px-2"
            type="button"
            onClick={handleClick_delete(locTpIndex)}
            disabled={status.isReadOnly}
          >
            <FontAwesomeIcon icon="times" className="fa-fw" />
          </button>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  update: (fields) =>
    dispatch({
      type: ADR_EDIT.LOCATION_WORKPERFORMED.TESTS_PERFORMED.UPDATE,
      tabId: ownProps.tabId,
      wpTabId: ownProps.wpTabId,
      clientId: ownProps.clientId,
      locTpIndex: ownProps.locTpIndex,
      fields,
    }),
});

const mapStateToProps = (state) => ({
  fieldTestTypes: state.feederLists.fieldTestTypes || [],
});

export default connect(mapStateToProps, mapDispatchToProps)(AdrLocTestPerformedRowV3);
